
import React from "react"
import { sendPassReset } from "../dbconnector/connector";
import Button from 'react-bootstrap/Button';
import { setErrorMessage } from "../tools/errorhandling";
import { useNavigate } from 'react-router-dom'






const Passwordreset = (props) => {
    const t = props.translation
    const navigate = useNavigate()
    const onBack = () => {
        navigate("/");
    }

    const onSubmit = (e) => {
        e.preventDefault()
        sendPassReset(document.getElementById("email").value).then((response) => {
            if (response.status === 200) {
                setMessage(t("message_mailsend"))
            } else {
                setErrorMessage(response.statusText);
            }
        })
    }
    const setMessage = async (message) => {
        document.getElementById("messagetext").innerText = message;
        document.getElementById("coverAllmessage").style.display = "block";
        document.getElementById("messagediv").style.display = "block";
    }
    const clearMessage = () => {
        document.getElementById("messagetext").innerText = "";
        document.getElementById("messagediv").style.display = "none";
        document.getElementById("coverAllmessage").style.display = "none";
        onBack()
    }

    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">

                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                           <center> <Button type="button" id="cancelButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button></center>
                        </div>
                    </div>
                </header>
                <center>
                    <div id="content">
                        <form className="pwdResetform" onSubmit={onSubmit} >
                            <label className='formtitle'>{t("forgotpassword")}</label>
                            <div className="pwdResetformchild">

                                <label className='labelhotel'>
                                    {t("Emailaddress")}:
                                </label>
                                <input id="email" name="email" className="normalinput" type='text' ></input>
                            </div>
                            <div className="two_Buttons">
                                <Button id="Back" type="submit" className='Savebutton' onClick={() => onBack()} >{t("Back")}</Button>
                                <Button id="passwordresetButton" type="submit" className='Savebutton'>{t("SendPWDReset")}</Button>
                            </div>
                        </form>

                    </div>
                </center>
            </div>
        </>
    )
}
export default Passwordreset